import { render, staticRenderFns } from "./RecordPlayIcon.vue?vue&type=template&id=c28c3f2a&"
import script from "./RecordPlayIcon.vue?vue&type=script&lang=js&"
export * from "./RecordPlayIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports